<template>
    <div>
        <b-container fluid class="mt-2 px-1 px-sm-3 pb-2 team-page">
            <b-row>
                <b-col cols="" class="">
                    <b-row>
                        <b-col cols="">

                            <div class="expiry-data d-flex justify-content-between align-items-center flex-wrap mb-3">
                                <h2 class="text-left mb-0">{{ $t('hazmatCheckPage.title') }}</h2>
                                <div class="justify-content-between justify-content-sm-center flex-wrap">
                                    <b-button @click="allowAddHazmatRecord = true"
                                        class="export equipment d-flex justify-content-center align-items-center mx-1 my-1 w-fit-content"
                                        variant="primary">
                                        <b-icon icon="plus" aria-hidden="true"></b-icon>
                                        <p class="mb-0 ml-2 text-white">{{ $t('hazmatCheckPage.addLoad') }}</p>
                                    </b-button>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <div class="data-table team-data-table table-custom-border rounded-top">
                                <div class="bg-white pt-3 pt-sm-4 rounded">
                                    <div class="table_row team_table_row">
                                        <div class="equipment-border filter-box" v-if="isTableMounted">
                                            <div class="d-flex mb-4 px-3 px-sm-4">
                                                <b-form-group class="text-left label font-weight-normal search-field mb-0">
                                                    <b-input-group class="username-input-field">
                                                        <b-form-input type="text" :placeholder="$t('hazmatCheckPage.search')"
                                                            v-model="filterFields.search" class="unit f-12"
                                                            @keyup.enter="getAllHazmatLoads()"></b-form-input>
                                                        <b-input-group-append>
                                                            <b-button variant="primary" @click="getAllHazmatLoads()">
                                                                <svg width="14" height="15" viewBox="0 0 14 15" fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg">
                                                                    <path
                                                                        d="M6.14286 11.7857C8.98318 11.7857 11.2857 9.48318 11.2857 6.64286C11.2857 3.80254 8.98318 1.5 6.14286 1.5C3.30254 1.5 1 3.80254 1 6.64286C1 9.48318 3.30254 11.7857 6.14286 11.7857Z"
                                                                        stroke="white" stroke-width="2"
                                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M10 10.5L13 13.5" stroke="white"
                                                                        stroke-width="2" stroke-linecap="round"
                                                                        stroke-linejoin="round" />
                                                                </svg>
                                                            </b-button>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </b-form-group>
                                                <div class="ml-auto align-items-center d-none d-sm-flex flex-wrap">
                                                    <div class="position-relative">
                                                        <div class="position-absolute notification-badge"
                                                            v-if="activeFiltersCount">
                                                            {{ activeFiltersCount }}
                                                        </div>
                                                        <button class="btn btn-filter-section"
                                                            @click="$bvModal.show('modal-filter')">
                                                            <div class="d-flex align-items-center">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                                                    height="24" viewBox="0 0 24 24" fill="none"
                                                                    stroke="currentColor" stroke-width="2"
                                                                    stroke-linecap="round" stroke-linejoin="round"
                                                                    class="lucide lucide-sliders-horizontal w-4 h-4"
                                                                    data-id="element-964">
                                                                    <line x1="21" x2="14" y1="4" y2="4"></line>
                                                                    <line x1="10" x2="3" y1="4" y2="4"></line>
                                                                    <line x1="21" x2="12" y1="12" y2="12"></line>
                                                                    <line x1="8" x2="3" y1="12" y2="12"></line>
                                                                    <line x1="21" x2="16" y1="20" y2="20"></line>
                                                                    <line x1="12" x2="3" y1="20" y2="20"></line>
                                                                    <line x1="14" x2="14" y1="2" y2="6"></line>
                                                                    <line x1="8" x2="8" y1="10" y2="14"></line>
                                                                    <line x1="16" x2="16" y1="18" y2="22"></line>
                                                                </svg>
                                                                <p class="mb-0 ml-2">{{ $t('hazmatCheckPage.filters') }}</p>
                                                            </div>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="!isTableMounted" class="mt-2"
                                            style="height: calc(100vh - 180px); overflow: hidden;">
                                            <b-skeleton-table :rows="17" :columns="7"
                                                :table-props="{ hover: true, responsive: true }"></b-skeleton-table>
                                        </div>
                                        <b-table v-else ref="tableRef" class="mt-2" responsive :fields="translatedFields" :items="items"
                                            hover :sticky-header="'calc(100vh - 280px)'" :current-page="currentPage"
                                            :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :no-local-sorting="true"
                                            :busy.sync="isBusy" :tbody-tr-class="'cursor-pointer'" :show-empty="emptyTable" @row-clicked="openHazmatDetails">
                                            <template #cell(status)="data">
                                                <b-button
                                                    class="btn f-14 pe-none d-flex justify-content-center align-items-center"
                                                    :variant="data.item.status === 'New' ? 'warning-status' : data.item.status === 'Rejected' ? 'danger-status' : data.item.status === 'Accepted' ? 'primary-status' : data.item.status === 'Open' ? 'success-status' : 'secondary-status'">
                                                    <p class="mb-0">{{ data.item.status }}</p>
                                                </b-button>
                                            </template>

                                        </b-table>
                                        <div class="entries-pagination px-0 px-sm-2" v-if="isTableMounted">
                                            <div class="d-flex align-items-center flex-wrap">
                                                <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
                                                    <b-form-select v-model="perPage" :options="pageOptions" />
                                                </div>
                                                <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-0 f-14">
                                                    {{ positionText }}
                                                </p>
                                                <div class="pagination">
                                                    <b-pagination v-model="currentPage" :total-rows="rows"
                                                        :per-page="perPage" aria-controls="my-table"></b-pagination>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
        <AddHazmatRecord :allowAddRecord="allowAddHazmatRecord" @close="allowAddHazmatRecord = false"
            @recordAdded="hazmatRecordAdded" />
        <b-modal id="modal-filter" centered no-close-on-backdrop :footer-class="'d-block p-3 m-0'"
            :body-class="'px-3 pt-3 pb-1'" no-close-on-esc>
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ $t('hazmatCheckPage.filtersModalTitle') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="body">
                <b-form-group :label="$t('hazmatCheckPage.statusLabel')" class="text-left select_arrow label mb-0">
                    <b-form-select class="input f-12 mb-3" :options="statusFilterOptions" v-model="filterFields.status" @change="getAllHazmatLoads()"></b-form-select>
                </b-form-group>

            </div>
            <template #modal-footer="">
                <div class="text-right modal-footer border-0 p-0 mb-0 mt-0 justify-content-between mx-0">
                    <b-button class="mx-0 mb-0 h-40px w-100px m-0 btn-outline-primary" variant="primary"
                        @click="resetFilterFields(); $bvModal.hide('modal-filter')">{{ $t('hazmatCheckPage.reset') }}</b-button>
                    <b-button class="mx-0 h-40px w-100px m-0 m-0" block
                        @click="$bvModal.hide('modal-filter')">{{ $t('hazmatCheckPage.close') }}</b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
import * as moment from "moment-timezone";
import AddHazmatRecord from "@/components/HazmatCheck/AddHazmatRecord.vue";
import { mapActions, mapGetters } from "vuex";
import 'vue2-datepicker/index.css';
export default {
    name: "HazmatCheck",
    components: { AddHazmatRecord },
    data() {
        return {
            momentFormat: {
                stringify: (date) => {
                    return date ? moment(date).format('ll') : ''
                },
                parse: (value) => {
          if (!value) return null
          const formats = [
            'll', 'LL',
            'MMM D, YYYY', 'MMMM D, YYYY',
            'M/D/YYYY', 'MM/DD/YYYY',
            'M-D-YYYY', 'MM-DD-YYYY',
            'YYYY-MM-DD', 'YYYY/MM/DD',
            'D MMM YYYY', 'D MMMM YYYY',
            'D/M/YYYY', 'DD/MM/YYYY',
          ]
          const m = moment(value, formats, true)
          if (m.isValid()) return m.toDate()
          const lenient = moment(value)
          return lenient.isValid() ? lenient.toDate() : null
        }
            },
            searchName: null,
            allowAddHazmatRecord: false,
            searchType: null,
            currentPage: 1,
            sortBy: undefined,
            isTableMounted: false,
            defaultData: {},
            sortDesc: undefined,
            emptyTable: false,
            isBusy: false,
            rows: 1,
            positionText: "",
            items: [],
            showDivision: false,
            showPublic: false,
            modelType: null,
            isTagDoc: false,
            archivedDocsCount: 0,
            sendCount: 0,
            receivedCount: 0,
            perPage: 25,
            selectedRows: [],
            pageOptions: [
                {
                    value: 10,
                    text: "10",
                },
                {
                    value: 25,
                    text: "25",
                },
                {
                    value: 50,
                    text: "50",
                },
                {
                    value: 100,
                    text: "100",
                },
            ],
            filterFields: {
                search: '',
                status: ''
            },

            errors: {
                date: null,
                name: null,
                document: null,
            },
            nameOptions: [],
        };
    },
    computed: {
        ...mapGetters(["company"]),
        translatedFields() {
            return [
                { label: this.$t('hazmatCheckPage.columnDriver'), key: "driver_name", sortable: true, thClass: 'font-table-weight-bold', stickyColumn: true, thStyle: { width: "200px" } },
                { key: "load_number", label: this.$t('hazmatCheckPage.columnLoad'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "reference_number", label: this.$t('hazmatCheckPage.columnReference'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "date", label: this.$t('hazmatCheckPage.columnAddDate'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "Status", label: this.$t('hazmatCheckPage.columnStatus'), sortable: true, thClass: 'font-table-weight-bold' },
            ];
        },
        statusFilterOptions() {
            return [
                { value: '', text: '' },
                { value: 'New', text: this.$t('hazmatCheckPage.statusNew') },
                { value: 'Open', text: this.$t('hazmatCheckPage.statusOpen') },
                { value: 'Accepted', text: this.$t('hazmatCheckPage.statusAccepted') },
                { value: 'Rejected', text: this.$t('hazmatCheckPage.statusRejected') },
                { value: 'Fixed', text: this.$t('hazmatCheckPage.statusFixed') },
            ];
        },
        activeFiltersCount() {
            return Object.keys(this.filterFields).reduce((count, key) => {
                if (
                    this.filterFields[key] !== '' &&
                    this.filterFields[key] !== null
                ) {
                    return count + 1;
                }
                return count;
            }, 0);
        },
    },
    methods: {
        ...mapActions([
            "setLoader",
            "setNotification",
            "getHazmatLoads"
        ]),
        hazmatRecordAdded(id) {
            if(id){
                this.$router.push({ name: 'LoadDetails', params: { id } });
            }
            else this.getAllHazmatLoads();
        },
        openHazmatDetails(item) {
            this.$router.push({ name: 'LoadDetails', params: { id: item.id } });
        },
        async resetFilterFields() {
            this.filterFields = {
                search: '',
                status: ''
            }
            await this.getAllHazmatLoads();
        },
        async getAllHazmatLoads() {
            try {
                this.isBusy = true
                let url = ""
                Object.keys(this.filterFields).map((key) => {
                    if (this.filterFields[key] !== '') {
                        url += `${key}=${this.filterFields[key]}&`
                    }
                })
                if (this.sortBy) {
                    url += `sort_field=${this.sortBy}&sort_order=${this.sortDesc ? "desc" : "asc"}&`
                }
                else {
                    url += `sort_field=date&sort_order=asc&`
                }

                url += `page=${this.currentPage}&page_size=${this.perPage}`
                const data = await this.getHazmatLoads({ url, company_id: this.userCompany });
                this.items = []
                if (data.total_entries_count) {
                    data.data.forEach((item) => {
                        this.items.push({
                            id: item.id,
                            driver_name: item.driver_name,
                            load_number: item.load_number,
                            reference_number: item.reference_number,
                            date: item.date ? moment(item.date).format('ll') : '',
                            status: item.status
                        })
                    })
                    this.rows = data.total_entries_count
                    const start = this.currentPage === 1 ? 1 : (this.perPage * (this.currentPage - 1)) + 1
                    const end = this.perPage * (this.currentPage - 1) + data.queryset_count
                    this.positionText = this.$t('hazmatCheckPage.positionText', { start, end, total: data.total_entries_count })
                }
                else {
                    this.rows = 0
                    this.positionText = this.$t('hazmatCheckPage.emptyPosition')
                }
                if (this.items.length === 0) this.emptyTable = true
                else this.emptyTable = false
                this.isBusy = false
                this.isTableMounted = true
            }
            catch (e) {
                this.isBusy = false
                this.isTableMounted = true
                console.log(e)
            }
        },

    },
    watch: {
        perPage: {
            async handler() {
                await this.getAllHazmatLoads();
            },
            immediate: true,
        },
        currentPage: {
            async handler() {
                await this.getAllHazmatLoads();
            },
        },
        sortBy: {
            async handler() {
                await this.getAllHazmatLoads();
            },
        },
        sortDesc: {
            async handler() {
                await this.getAllHazmatLoads();
            },
        },
        filterFields: {
            handler() {
                this.currentPage = 1
            },
            deep: true
        },

    },
};
</script>
